import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EMRComponent } from './EMR.component';

const routes: Routes = [
   {path:'',component:EMRComponent},
   
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmrRoutingModule { }
